import { useState, useRef, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { Navbar } from "../../../components/Navbar/Navbar";
import { Footer } from "../../../components/Footer/Footer";
import { Banner } from "../../../components/Banner/Banner";
import topImage from "../../../assets/images/BannerTop.png";
import X from "../../../assets/images/galleryWriteX.png";
import "./GalleryWrite.css";

export const GalleryWrite = () => {
    const BOARD_URL = process.env.REACT_APP_BOARD_API_URL || 'http://localhost:5001';
    const navigate = useNavigate();
    
    // 상태 관리
    const [title, setTitle] = useState("");
    const [content, setContent] = useState(""); // UI에는 있지만 DB 스키마에 없다면 저장은 안 될 수 있음
    const [file, setFile] = useState(null); // 실제 전송할 파일 객체
    const [preview, setPreview] = useState(null); // 화면에 보여줄 미리보기 URL

    // 파일 인풋을 제어하기 위한 Ref
    const fileInputRef = useRef(null);

    // 로그인 체크
    useEffect(() => {
        const token = localStorage.getItem('token');
        if (!token) {
            alert("로그인이 필요합니다.");
            navigate('/adLogin');
        }
    }, [navigate]);

    // 1. 이미지 선택 핸들러
    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        if (selectedFile) {
            setFile(selectedFile);
            // 미리보기 URL 생성
            setPreview(URL.createObjectURL(selectedFile));
        }
    };

    // 2. "이미지 추가" 버튼 클릭 시 숨겨진 input 실행
    const triggerFileInput = () => {
        fileInputRef.current.click();
    };

    // 3. 이미지 삭제 핸들러 (X 버튼)
    const handleRemoveImage = () => {
        setFile(null);
        setPreview(null);
        if (fileInputRef.current) {
            fileInputRef.current.value = ""; // input 초기화
        }
    };

    // 4. 등록 버튼 핸들러 (서버 전송)
    const handleSubmit = async () => {
        if (!title.trim()) {
            alert("제목을 입력해주세요.");
            return;
        }
        if (!file) {
            alert("이미지를 반드시 등록해야 합니다.");
            return;
        }

        const token = localStorage.getItem('token');
        
        // ★ 중요: 이미지 전송을 위해 FormData 사용
        const formData = new FormData();
        formData.append('title', title);
        formData.append('image', file); // 백엔드의 upload.single('image')와 이름 일치해야 함
        formData.append('content', content); // ✅ [추가] 이 줄이 없으면 추가해주세요!

        // (참고) 현재 백엔드 스키마에 content가 없다면 이 내용은 무시될 수 있습니다.
        // 만약 content도 저장하려면 백엔드 수정 필요.
        // formData.append('content', content); 

        try {
            const res = await fetch(`${BOARD_URL}/gallery`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}` 
                    // Content-Type은 fetch가 자동으로 설정하므로 생략
                },
                body: formData
            });

            if (res.ok) {
                alert("갤러리가 등록되었습니다.");
                navigate('/gallery');
            } else {
                const data = await res.json();
                alert(data.message || "등록 실패");
            }
        } catch (err) {
            console.error(err);
            alert("서버 오류가 발생했습니다.");
        }
    };

    return(
        <>
        <Navbar />
        <Banner title="갤러리" />
        <div className="gallery-container">
            
                        <input
                            className="gallery-input"
                            type="text"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                            placeholder="제목을 입력해 주세요."
                        />


            {/* 중간: 이미지 추가 버튼 */}

                    {/* 클릭 시 파일 선택창 열림 */}
                    <div className="gallery-btn-wrap" onClick={triggerFileInput} style={{cursor: 'pointer'}}>
                        <div className="gallery-btn-add">이미지 추가 +</div>
                    </div>
                    {/* 숨겨진 파일 인풋 */}
                    <input 
                        type="file" 
                        ref={fileInputRef} 
                        style={{display: 'none'}} 
                        accept="image/*"
                        onChange={handleFileChange}
                    />


                    <textarea
                        className="gallery-textarea"
                        value={content}
                        onChange={(e) => setContent(e.target.value)}
                        placeholder="내용을 입력하세요."
                        rows={6}
                    />
                    
                    {/* 미리보기 이미지가 있을 때만 표시 */}
                    {preview && (
                        <div className="bot-frame">
                            <img src={preview} alt="미리보기" className="main-image"/>
                            {/* X 버튼 클릭 시 이미지 삭제 */}
                            <img 
                                src={X} 
                                alt="삭제" 
                                className="remove-icon" 
                                onClick={handleRemoveImage}
                                style={{cursor: 'pointer', width: '2vw', height: '2vw'}}
                            />
                        </div>
                    )}


            {/* 하단 등록 버튼 */}
            <div className="admin">
                <div className="admin-box" onClick={handleSubmit} style={{cursor: 'pointer'}}>
                    <div className="admin-text">등록</div>
                </div>
                {/* 취소 버튼 추가 (선택사항) */}
                <div 
                    className="admin-box" 
                    onClick={() => navigate('/gallery')} 
                    style={{cursor: 'pointer', background: '#fff',marginLeft: '1vw'}}
                >
                    <div className="admin-text" style={{color:'#5a5a5aff'}}>취소</div>
                </div>
            </div>
        </div>

        <Footer />

        </>
    );
}